import React from 'react'
import styled from 'styled-components'

const Page = styled.div`
  min-height: 100%;
  box-sizing: border-box;
  padding: 48px 24px;
  display: flex;
  justify-content: center;
`

const Card = styled.div`
  width: 100%;
  max-width: 900px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 32px;
  line-height: 1.55;
  overflow: scroll;

  h1 {
    margin-top: 0;
    margin-bottom: 8px;
    font-size: 2rem;
  }

  h2 {
    margin-top: 28px;
    margin-bottom: 12px;
    font-size: 1.2rem;
  }

  h3 {
    margin-top: 18px;
    margin-bottom: 8px;
    font-size: 1rem;
  }

  p {
    margin: 0 0 14px;
  }

  ul {
    margin-top: 0;
    margin-bottom: 14px;
    padding-left: 20px;
  }

  li {
    margin-bottom: 8px;
  }

  @media only screen and (max-width: 700px) {
    padding: 24px;
  }
`

const Privacy = () => {
  return (
    <Page>
      <Card>
        <h1>Privacy Policy</h1>
        <p><strong>Last updated:</strong> February 2026</p>

        <p>
          This Privacy Policy describes how WordGrid (&ldquo;WordGrid,&rdquo; &ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;)
          collects, uses, and discloses information when you use the WordGrid mobile application (the
          &ldquo;App&rdquo;).
        </p>

        <p>
          By using the App, you agree to the collection and use of information in accordance with this
          Privacy Policy.
        </p>

        <h2>1. Information We Collect</h2>
        <h3>Personal Information</h3>
        <p>
          WordGrid does not require user accounts and does not intentionally collect personal information
          such as names, email addresses, phone numbers, or payment details.
        </p>

        <h3>Usage Data</h3>
        <p>
          We collect limited, non-personal usage data through PostHog, a third-party analytics provider.
          This may include:
        </p>
        <ul>
          <li>Device type, operating system, and app version</li>
          <li>Anonymous identifiers</li>
          <li>App interactions (e.g., puzzle activity, button taps)</li>
          <li>General usage metrics and performance data</li>
        </ul>
        <p>
          This information is used solely to monitor performance, improve functionality, and enhance user
          experience.
        </p>
        <p>We do not sell personal information.</p>

        <h2>2. Multiplayer &amp; Game Data</h2>
        <p>
          To enable real-time multiplayer features and puzzle persistence, gameplay data (such as board
          state and puzzle progress) may be temporarily stored on our servers.
        </p>
        <p>This data is not associated with personal identity.</p>

        <h2>3. Third-Party Services</h2>
        <p>
          We use PostHog for analytics. PostHog may process data in accordance with its own privacy
          policy. We encourage you to review PostHog&rsquo;s privacy practices for additional information.
        </p>

        <h2>4. Data Retention</h2>
        <p>
          We retain usage and gameplay data only for as long as reasonably necessary to operate and improve
          the App.
        </p>

        <h2>5. Children&rsquo;s Privacy</h2>
        <p>
          The App is not directed to children under the age of 13. We do not knowingly collect personal
          information from children under 13.
        </p>
        <p>
          If we become aware that personal information from a child under 13 has been collected, we will
          take steps to delete such information.
        </p>

        <h2>6. Data Security</h2>
        <p>
          We implement reasonable administrative and technical safeguards to protect information collected
          through the App. However, no method of transmission over the internet or electronic storage is
          completely secure.
        </p>

        <h2>7. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will be reflected by updating
          the &ldquo;Last updated&rdquo; date above. Continued use of the App after changes constitutes acceptance
          of the updated policy.
        </p>

        <h2>8. Contact</h2>
        <p>
          If you have any questions about this Privacy Policy, you may contact us at:
        </p>
        <p>
          <a href='mailto:feedback@wordgrid.io'>feedback@wordgrid.io</a>
        </p>
      </Card>
    </Page>
  )
}

export default Privacy
